import React from "react";

const ViewMmse = ({ data, ismodalopen, setHtmlModal }) => {
  if (!ismodalopen || !data || !data.json_data) return null;

  const json = data.json_data;

  const closeModal = () => setHtmlModal(false);

  const questions = [
    { q: "What is the year? Season? Date? Day of the week? Month?", key: "qanswer_2_2" },
    { q: "Where are we now: State? County? Town/City? Hospital? Floor?", key: "qanswer_2_3" },
    { q: "The examiner names three unrelated objects clearly and slowly, then asks the patient to name all three of them. Number of trials:", key: "qanswer_2_4" },
    { q: "I would like you to count backward from 100 by sevens. Stop after five answers. Alternative: Spell WORLD backwards.", key: "qanswer_2_5" },
    { q: "Earlier I told you the names of three things. Can you tell me what those were?", key: "qanswer_2_6" },
    { q: "Show the patient two simple objects, such as a wristwatch and a pencil, and ask the patient to name them.", key: "qanswer_2_7" },
    { q: "Repeat the phrase: No ifs, ands, or buts.", key: "qanswer_2_8" },
    { q: "Take the paper in your right hand, fold it in half, and put it on the floor.", key: "qanswer_2_9" },
    { q: "Please read this and do what it says. (Written instruction: 'Close your eyes')", key: "qanswer_2_10" },
    { q: "Make up and write a sentence about anything. This sentence must contain a noun and a verb.", key: "qanswer_2_11" },
    { q: "Please copy this picture. All 10 angles must be present and two must intersect.", key: "qanswer_2_12" },
  ];

  const scores = [1, 2, 3, 4, 5];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto text-start">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{json.form_name}</h2>
          <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">&times;</button>
        </div>

        {/* Instructions */}
        <div className="mb-4">
          <p className="font-bold mb-2">Instructions:</p>
          <p className="text-gray-700">
            Ask the questions in the order listed. Score one point for each correct response within each question or activity.
          </p>
        </div>

        {/* Patient Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="font-bold text-base">Patient Name</label>
            <p>{json.patient_name}</p>
          </div>
          <div>
            <label className="font-bold text-base">Date</label>
            <p>{json.cdate}</p>
          </div>
        </div>

        {/* Questions */}
        {questions.map((q, idx) => (
          <div key={idx} className="mb-6">
            <label className="font-bold text-base">{q.q}</label>
            <div className="flex flex-wrap gap-2 mt-2 relative">
              {scores.map((val, i) => (
                <div key={val} className="flex flex-col items-center">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-sans border ${
                      Number(json[q.key]) === val
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white border-gray-300 text-black"
                    }`}
                  >
                    {val}
                  </span>
                  {i === 0 && <span className="text-xs text-gray-500 mt-1">Min Score</span>}
                  {i === scores.length - 1 && <span className="text-xs text-gray-500 mt-1">Max Score</span>}
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Total Score */}
        <div className="mt-6 p-4 bg-gray-100 border-l-4 border-blue-600 rounded-md text-gray-800">
          <p className="font-semibold">Total Score:</p>
          <p className="text-lg font-bold">{json.total_score}</p>
        </div>
      </div>
    </div>
  );
};

export default ViewMmse;
